const toNumber = (value) => {
  const normalized = String(value || "").replace(",", ".").trim();
  if (!normalized) return 0;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : 0;
};

const hasText = (value) => String(value ?? "").trim() !== "";

export const rowHasAnyDataNovos = (row = {}) =>
  Boolean(
    hasText(row.vagao1) ||
      hasText(row.vagao2) ||
      hasText(row.fabricante) ||
      hasText(row.quantidadePecas) ||
      hasText(row.metragemPecas) ||
      hasText(row.furos) ||
      hasText(row.qtdFuros) ||
      hasText(row.defeito) ||
      hasText(row.qtdDefeito) ||
      hasText(row.motivoDefeito)
  );

const buildValidationResult = ({ formErrors = [], rowErrors = [], emptyMessage = "" }) => {
  const modalGroups = [];

  if (emptyMessage) {
    modalGroups.push({
      id: "sem-informacao",
      title: "Ficha",
      errors: [emptyMessage],
    });
  } else {
    if (formErrors.length) {
      modalGroups.push({
        id: "dados-ficha",
        title: "Dados da ficha",
        errors: formErrors,
      });
    }

    rowErrors.forEach((rowGroup) => {
      modalGroups.push({
        id: `linha-${rowGroup.line}`,
        title: rowGroup.label,
        errors: rowGroup.errors,
      });
    });
  }

  const flatErrors = emptyMessage
    ? [emptyMessage]
    : [
        ...formErrors,
        ...rowErrors.flatMap((rowGroup) => rowGroup.errors.map((error) => `${rowGroup.label}: ${error}`)),
      ];

  return {
    isValid: flatErrors.length === 0,
    firstError: flatErrors[0] || "",
    flatErrors,
    modalGroups,
    totalErrors: flatErrors.length,
  };
};

export function validateCadastroTrilhosNovos({ form = {}, rows = [] }) {
  const safeRows = Array.isArray(rows) ? rows : [];
  const hasAnyRowData = safeRows.some((row) => rowHasAnyDataNovos(row));

  if (!hasAnyRowData) {
    return buildValidationResult({
      emptyMessage: "Nenhuma informação preenchida na tabela.",
    });
  }

  const formErrors = [];
  const rowErrors = [];

  if (!hasText(form.data)) formErrors.push("Data: preenchimento obrigatório.");
  if (!hasText(form.perfilTrilho)) formErrors.push("Perfil de trilho: preenchimento obrigatório.");
  if (!hasText(form.origem)) formErrors.push("Origem: preenchimento obrigatório.");

  safeRows.forEach((row) => {
    if (!rowHasAnyDataNovos(row)) return;

    const line = Number(row?.id) || 0;
    const label = line > 0 ? `Linha ${line}` : "Linha";
    const currentRowErrors = [];
    const vagao1 = String(row?.vagao1 || "").trim();
    const vagao2 = String(row?.vagao2 || "").trim();
    const fabricante = String(row?.fabricante || "").trim();
    const qtdRaw = String(row?.quantidadePecas || "").trim();
    const metrosRaw = String(row?.metragemPecas || "").trim();
    const furos = String(row?.furos || "").trim();
    const qtdFurosRaw = String(row?.qtdFuros || "").trim();
    const defeito = String(row?.defeito || "").trim();
    const qtdDefeitoRaw = String(row?.qtdDefeito || "").trim();
    const motivoDefeito = String(row?.motivoDefeito || "").trim();

    const quantidadePecas = toNumber(qtdRaw);
    const metragem = toNumber(metrosRaw);
    const qtdFuros = toNumber(qtdFurosRaw);
    const qtdDefeito = toNumber(qtdDefeitoRaw);

    if (!vagao1) currentRowErrors.push("Vagão 1 é obrigatório.");
    if (!fabricante) currentRowErrors.push("Fabricante é obrigatório.");
    if (!qtdRaw || quantidadePecas <= 0) currentRowErrors.push("Quantidade de peças é obrigatória.");
    if (!metrosRaw || metragem <= 0) currentRowErrors.push("Metragem é obrigatória.");

    if (metragem > 12 && (!vagao1 || !vagao2)) {
      currentRowErrors.push("Para metragem acima de 12 metros, Vagão 1 e Vagão 2 são obrigatórios.");
    }

    if (furos === "Sim" && (!qtdFurosRaw || qtdFuros <= 0)) {
      currentRowErrors.push("Com Furos = Sim, o campo Qtd. com furos é obrigatório.");
    }

    if (defeito === "Sim" && (!qtdDefeitoRaw || qtdDefeito <= 0)) {
      currentRowErrors.push("Com Defeito = Sim, o campo Qtd. com defeito é obrigatório.");
    }

    if (defeito === "Sim" && !motivoDefeito) {
      currentRowErrors.push("Com Defeito = Sim, o campo Motivo do defeito é obrigatório.");
    }

    if (currentRowErrors.length) {
      rowErrors.push({
        line,
        label,
        errors: currentRowErrors,
      });
    }
  });

  return buildValidationResult({ formErrors, rowErrors });
}
